import dayjs from "dayjs";
import duration from "dayjs/plugin/duration";

dayjs.extend(duration);

export const getDateRange = (checkInDate, checkOutDate) => {
  let end = dayjs(checkOutDate, "YYYY-MM-DD");
  let start = dayjs(checkInDate, "YYYY-MM-DD");
  const NoOfNights = dayjs.duration(end.diff(start)).asDays();
  let dataArray = [];
  for (let i = 0; i <= NoOfNights; i++) {
    if (i == 0) {
      dataArray.push(dayjs(checkInDate).format("DD-MM-YYYY"));
    } else if (i == NoOfNights) {
      dataArray.push(dayjs(checkOutDate).format("DD-MM-YYYY"));
    } else {
      dataArray.push(
        dayjs(checkInDate).clone().add(i, "days").format("DD-MM-YYYY")
      );
    }
  }
  return dataArray;
};
